import { MobXProviderContext, observer } from 'mobx-react';
import { ContactModelV2 } from 'Models/ContactModelV2';
import React, { useCallback } from 'react';
import { useNavigate } from 'react-router';
import { RootStoreProps } from 'Stores/RootStore.types';
import { Button } from '~/lib/ui/button';
import {
  SidebarGroup,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuItem,
} from '~/lib/ui/sidebar';
import { ContactDetailsInfoContent } from './ContactDetailsInfoContent';
import { ContactDetailsInfoProps } from './index.types';

/**
 * ContactDetailsInfo is a component that displays the contact details in the sidebar.
 */
export const ContactDetailsInfo = observer(
  ({ contact, openContactDetails }: ContactDetailsInfoProps) => {
    const navigate = useNavigate();

    const { person: personStore } = React.useContext(
      MobXProviderContext
    ) as RootStoreProps;

    const isExternalContact =
      contact instanceof ContactModelV2 && contact.source !== 'Bhive';

    const handleEdit = useCallback(() => {
      if (isExternalContact) {
        personStore.setEditContact(contact);
        void navigate('/addressBook/contact', { state: { from: '/contacts' } });
      }
    }, [contact, isExternalContact, navigate, personStore]);

    return (
      <SidebarGroup className="px-[7px]">
        <SidebarGroupLabel className="flex justify-between pb-2">
          <h3 className="text-base font-bold">Contact info</h3>
          {isExternalContact && (
            <Button onClick={handleEdit} variant="link">
              Edit
            </Button>
          )}
        </SidebarGroupLabel>
        <SidebarMenu className="px-0">
          <SidebarMenuItem className="flex flex-col gap-2.5 mt-0 pt-0">
            <ContactDetailsInfoContent
              contact={contact}
              openContactDetails={openContactDetails}
            />
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarGroup>
    );
  }
);